<mat-card appearance="outlined" class="demo-inline-calendar-card">
  <mat-calendar
  [minDate]="minDate"
    [startAt]="startAt"
    [(selected)]="selectedDate"
    (selectedChange)="onDateSelection($event)">
  </mat-calendar>
</mat-card>
